<template>
  <base-button type="button" class="btn-primary" text="ダウンロード" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'DownloadButton',
  components: {
    BaseButton,
  },
}
</script>
